import { FieldType } from 'module/types/filter-field/field/field';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { SuppressKeyboardEventParams } from 'ag-grid-community';

export const getCellEditorPopupPosition = ({
  type,
  fieldName,
}: FilterableField) => {
  return [
    FieldType.Date,
    FieldType.Assignee,
    FieldType.SingleUser,
    FieldType.MultiUser,
    FieldType.SingleSelect,
    FieldType.MultiSelect,
  ].includes(type) || fieldName.toLowerCase() === 'status'
    ? 'under'
    : 'over';
};
export const suppressEnterKey = ({
  editing,
  event,
}: SuppressKeyboardEventParams): boolean => {
  const eventCode = event.code.toLowerCase();

  if (editing && ['enter', 'numpadenter'].includes(eventCode)) {
    return true;
  }

  return false;
};

export const suppressEnterAndTabKey = ({
  editing,
  event,
}: SuppressKeyboardEventParams): boolean => {
  const eventCode = event.code.toLowerCase();

  if (editing && ['enter', 'numpadenter', 'tab'].includes(eventCode)) {
    return true;
  }

  return false;
};
